import Vue from 'vue';
const Skyzone = () => import('./Skyzone.vue');
window.showSkyzone = function (idStr, props) {
  new Vue({
    el: idStr + 'Child',
    render: (h) =>
      h(Skyzone, {
        props: props,
      }),
  });
};
